<template>
  <section class="mt-5 pt-5" style="background: white;">
    <h4 class="text-center" style="color: ">Compare os planos</h4>
    <table class="mx-auto shadow" style="width: 80%; max-width: 1080px; background: white; border: 1px solid #f3f3f4; ">
      <thead>
        <tr class="d-flex" style="border-bottom: 2px solid #f3f3f4; background-color: #f7f7f7;">
          <th class="table-col-2" style="font-weight:500">Detalhes</th>
          <th v-for="(plan, index) in planos.planos" :key="index" class="table-col-1" style="font-weight:500;">
            {{ plan.nome }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr class="d-flex " v-for="det in tableDetails" :key="det.id">
          <template v-if="!det.title">
            <th class="table-col-2">
              {{ det.desc }}
            </th>
            <th v-for="(plan, index) in planos.planos" :key="index" class="table-col-1">
                <template v-if="!isBoolean(det[plan.nome_tag])">
                  <strong
                    v-html="det[plan.nome_tag]"
                    v-if="det[plan.nome_tag][0] !== 'i'"
                  />
                  <span
                    v-else
                  >
                    {{ det[plan.nome_tag] }}
                    <i class="fa fa-check text-success" style="font-size:25px"></i>
                  </span>
                </template>
                <template v-else>
                  <i class="fa fa-check text-success" style="font-size:25px"
                    v-if="det[plan.nome_tag] && !Number.isInteger(det[plan.nome_tag])"></i>
                  <i class="fa fa-times text-danger" style="font-size:25px" v-else></i>
                </template>

            </th>

            <!-- <th class="table-col-1"> -->
            <!--     <i class="fa fa-check text-success" style="font-size:25px" v-if="det.ba && !Number.isInteger(det.ba)"></i> -->
            <!--     <i class="fa fa-times text-danger" style="font-size:25px" v-else></i> -->
            <!--     <strong v-if="Number.isInteger(det.ba)">{{det.ba}}</strong> -->
            <!-- </th> -->
            <!-- <th class="table-col-1"> -->
            <!--     <i class="fa fa-check text-success" style="font-size:25px" v-if="det.in && !Number.isInteger(det.in)"></i> -->
            <!--     <i class="fa fa-times text-danger" style="font-size:25px" v-else></i> -->
            <!--     <strong v-if="Number.isInteger(det.in)">{{det.in}}</strong> -->
            <!-- </th> -->
            <!-- <th class="table-col-1"> -->
            <!--     <i class="fa fa-check text-success" style="font-size:25px" v-if="det.av && !Number.isInteger(det.av)"></i> -->
            <!--     <strong v-if="Number.isInteger(det.av)">{{det.av}}</strong> -->
            <!-- </th> -->
          </template>
          <template v-else>
            <th class="table-col-full">{{ det.desc }}</th>
          </template>
        </tr>
      </tbody>

    </table>
  </section>
</template>
<script>
export default {
  props: {
    planos: { Type: Object },
  },
  data() {
    return {

      tableDetails: [
        {
          'id': 'RG',
          'desc': 'Recursos gerais',
          'title': true
        },
        {
          'id': 'usu',
          'desc': 'Usuário(s)',
          'erp2_0-2023': '1',
          'erp2_1-2023': '3',
          'erp2_2-2023': '10',
          'erp3_0-2023': '1',
          'erp3_1-2023': '3',
          'erp3_2-2023': '3',
          'erp3_3-2023': '10',
          'erp3_free': '1',
          'erp4_0-2025': '1',
          'erp4_1-2025': '3',
          'erp4_free': '1',
          'erp5_0-2026': '1',
          'erp5_1-2026': '3',
          'erp5_2-2026': '10',
          'title': false
        },
        {
          'id': 'imp ',
          'desc': 'Importar dados de cliente pelo CNPJ da SEFAZ/Receita',
          'erp2_0-2023': true,
          'erp2_1-2023': true,
          'erp2_2-2023': true,
          'erp3_0-2023': true,
          'erp3_1-2023': true,
          'erp3_2-2023': true,
          'erp3_3-2023': true,
          'erp3_free': true,
          'erp4_0-2025': true,
          'erp4_1-2025': true,
          'erp4_free': true,
          'erp5_0-2026': true,
          'erp5_1-2026': true,
          'erp5_2-2026': true,
          'title': false
        },
        {
          'id': 'imp',
          'desc': 'Importar cadastros de produtos e clientes por XML',
          'erp2_0-2023': true,
          'erp2_1-2023': true,
          'erp2_2-2023': true,
          'erp3_0-2023': true,
          'erp3_1-2023': true,
          'erp3_2-2023': true,
          'erp3_3-2023': true,
          'erp3_free': true,
          'erp4_0-2025': true,
          'erp4_1-2025': true,
          'erp4_free': true,
          'erp5_0-2026': true,
          'erp5_1-2026': true,
          'erp5_2-2026': true,
          'title': false
        },
        {
          'id': 'gradeprod',
          'desc': 'Grade de produtos (cor, tamanho)',
          'erp2_0-2023': true,
          'erp2_1-2023': true,
          'erp2_2-2023': true,
          'erp3_0-2023': true,
          'erp3_1-2023': true,
          'erp3_2-2023': true,
          'erp3_3-2023': true,
          'erp3_free': true,
          'erp4_0-2025': true,
          'erp4_1-2025': true,
          'erp4_free': true,
          'erp5_0-2026': true,
          'erp5_1-2026': true,
          'erp5_2-2026': true,
          'title': false
        },
        {
          'id': 'imgprod',
          'desc': 'Imagens nos produtos',
          'erp2_0-2023': true,
          'erp2_1-2023': true,
          'erp2_2-2023': true,
          'erp3_0-2023': true,
          'erp3_1-2023': true,
          'erp3_2-2023': true,
          'erp3_3-2023': true,
          'erp3_free': true,
          'erp4_0-2025': true,
          'erp4_1-2025': true,
          'erp4_free': true,
          'erp5_0-2026': true,
          'erp5_1-2026': true,
          'erp5_2-2026': true,
          'title': false
        },
        {
          'id': 'tabpre',
          'desc': 'Tabela de preço',
          'erp2_0-2023': true,
          'erp2_1-2023': true,
          'erp2_2-2023': true,
          'erp3_0-2023': true,
          'erp3_1-2023': true,
          'erp3_2-2023': true,
          'erp3_3-2023': true,
          'erp3_free': true,
          'erp4_0-2025': true,
          'erp4_1-2025': true,
          'erp4_free': true,
          'erp5_0-2026': true,
          'erp5_1-2026': true,
          'erp5_2-2026': true,
          'title': false
        },
        {
          'id': 'tabdesc',
          'desc': 'Tabela de descontos',
          'erp2_0-2023': true,
          'erp2_1-2023': true,
          'erp2_2-2023': true,
          'erp3_0-2023': true,
          'erp3_1-2023': true,
          'erp3_2-2023': true,
          'erp3_3-2023': true,
          'erp3_free': true,
          'erp4_0-2025': true,
          'erp4_1-2025': true,
          'erp4_free': true,
          'erp5_0-2026': true,
          'erp5_1-2026': true,
          'erp5_2-2026': true,
          'title': false
        },
        {
          'id': 'suporte',
          'desc': 'Suporte',
          'title': true
        },
        {
          'id': 'tut',
          'desc': 'Acesso a base de conhecimento e vídeos tutoriais',
          'erp2_0-2023': true,
          'erp2_1-2023': true,
          'erp2_2-2023': true,
          'erp3_0-2023': true,
          'erp3_1-2023': true,
          'erp3_2-2023': true,
          'erp3_3-2023': true,
          'erp3_free': true,
          'erp4_0-2025': true,
          'erp4_1-2025': true,
          'erp4_free': true,
          'erp5_0-2026': true,
          'erp5_1-2026': true,
          'erp5_2-2026': true,
          'title': false
        },
        {
          'id': 'nfeEnt',
          'desc': 'Abertura de tickets',
          'erp2_0-2023': true,
          'erp2_1-2023': true,
          'erp2_2-2023': true,
          'erp3_0-2023': true,
          'erp3_1-2023': true,
          'erp3_2-2023': true,
          'erp3_3-2023': true,
          'erp3_free': true,
          'erp4_0-2025': true,
          'erp4_1-2025': true,
          'erp4_free': true,
          'erp5_0-2026': true,
          'erp5_1-2026': true,
          'erp5_2-2026': true,
          'title': false
        },
        {
          'id': 'chat',
          'desc': 'Suporte via chat',
          'erp2_0-2023': true,
          'erp2_1-2023': true,
          'erp2_2-2023': true,
          'erp3_0-2023': true,
          'erp3_1-2023': true,
          'erp3_2-2023': true,
          'erp3_3-2023': true,
          'erp3_free': true,
          'erp4_0-2025': true,
          'erp4_1-2025': true,
          'erp4_free': true,
          'erp5_0-2026': true,
          'erp5_1-2026': true,
          'erp5_2-2026': true,
          'title': false
        },
        {
          'id': 'fat',
          'desc': 'Faturamento',
          'title': true
        },
        {
          'id': 'fatlimit',
          'desc': 'Limite de notas fiscais eletrônicas (NF-e)',
          'erp2_0-2023': '30<span class="text-[#3F3F41] text-[14px] font-normal">/mês</span>',
          'erp2_1-2023': 'ilimitada',
          'erp2_2-2023': 'ilimitada',
          'erp3_0-2023': '30<span class="text-[#3F3F41] text-[14px] font-normal">/mês</span>',
          'erp3_1-2023': 'ilimitada',
          'erp3_2-2023': 'ilimitada',
          'erp3_3-2023': 'ilimitada',
          'erp3_free': '5',
          'erp4_0-2025': '30<span class="text-[#3F3F41] text-[14px] font-normal">/mês</span>',
          'erp4_1-2025': 'ilimitada',
          'erp4_free': '5',
          'erp5_0-2026': '30<span class="text-[#3F3F41] text-[14px] font-normal">/mês</span>',
          'erp5_1-2026': '100<span class="text-[#3F3F41] text-[14px] font-normal">/mês</span>',
          'erp5_2-2026': 'ilimitada',
          'title': false
        },
        {
          'id': 'cert',
          'desc': 'Certificado A1 e A3',
          'erp2_0-2023': true,
          'erp2_1-2023': true,
          'erp2_2-2023': true,
          'erp3_0-2023': true,
          'erp3_1-2023': true,
          'erp3_2-2023': true,
          'erp3_3-2023': true,
          'erp3_free': true,
          'erp4_0-2025': true,
          'erp4_1-2025': true,
          'erp4_free': true,
          'erp5_0-2026': true,
          'erp5_1-2026': true,
          'erp5_2-2026': true,
          'title': false
        },
        {
          'id': 'calcimp',
          'desc': 'Cálculo automático de impostos',
          'erp2_0-2023': true,
          'erp2_1-2023': true,
          'erp2_2-2023': true,
          'erp3_0-2023': true,
          'erp3_1-2023': true,
          'erp3_2-2023': true,
          'erp3_3-2023': true,
          'erp3_free': true,
          'erp4_0-2025': true,
          'erp4_1-2025': true,
          'erp4_free': true,
          'erp5_0-2026': true,
          'erp5_1-2026': true,
          'erp5_2-2026': true,
          'title': false
        },
        {
          'id': 'gerxml',
          'desc': 'Geração do XML por período',
          'erp2_0-2023': true,
          'erp2_1-2023': true,
          'erp2_2-2023': true,
          'erp3_0-2023': true,
          'erp3_1-2023': true,
          'erp3_2-2023': true,
          'erp3_3-2023': true,
          'erp3_free': true,
          'erp4_0-2025': true,
          'erp4_1-2025': true,
          'erp4_free': true,
          'erp5_0-2026': true,
          'erp5_1-2026': true,
          'erp5_2-2026': true,
          'title': false
        },
        {
          'id': 'envxml',
          'desc': 'Envio de XML e DANFE por e-mail',
          'erp2_0-2023': true,
          'erp2_1-2023': true,
          'erp2_2-2023': true,
          'erp3_0-2023': true,
          'erp3_1-2023': true,
          'erp3_2-2023': true,
          'erp3_3-2023': true,
          'erp3_free': true,
          'erp4_0-2025': true,
          'erp4_1-2025': true,
          'erp4_free': true,
          'erp5_0-2026': true,
          'erp5_1-2026': true,
          'erp5_2-2026': true,
          'title': false
        },
        {
          'id': 'consrnfs',
          'desc': 'Consulta e relatório de notas fiscais de saída',
          'erp2_0-2023': true,
          'erp2_1-2023': true,
          'erp2_2-2023': true,
          'erp3_0-2023': true,
          'erp3_1-2023': true,
          'erp3_2-2023': true,
          'erp3_3-2023': true,
          'erp3_free': false,
          'erp4_0-2025': true,
          'erp4_1-2025': true,
          'erp4_free': false,
          'erp5_0-2026': true,
          'erp5_1-2026': true,
          'erp5_2-2026': true,
          'title': false
        },
        {
          'id': 'nfce',
          'desc': 'Nota fiscal de consumidor eletrônica (NFC-e)',
          'erp2_0-2023': true,
          'erp2_1-2023': true,
          'erp2_2-2023': true,
          'erp3_0-2023': true,
          'erp3_1-2023': true,
          'erp3_2-2023': true,
          'erp3_3-2023': true,
          'erp3_free': true,
          'erp4_0-2025': true,
          'erp4_1-2025': true,
          'erp4_free': true,
          'erp5_0-2026': '30<span class="text-[#3F3F41] text-[14px] font-normal">/mês</span>',
          'erp5_1-2026': '100<span class="text-[#3F3F41] text-[14px] font-normal">/mês</span>',
          'erp5_2-2026': 'ilimitada',

          'title': false
        },
        {
          'id': 'vend',
          'desc': 'Vendas',
          'title': true
        },
        {
          'id': 'grade',
          'desc': 'Orçamento',
          'erp2_0-2023': true,
          'erp2_1-2023': true,
          'erp2_2-2023': true,
          'erp3_0-2023': true,
          'erp3_1-2023': true,
          'erp3_2-2023': true,
          'erp3_3-2023': true,
          'erp3_free': true,
          'erp4_0-2025': true,
          'erp4_1-2025': true,
          'erp4_free': true,
          'erp5_0-2026': true,
          'erp5_1-2026': true,
          'erp5_2-2026': true,
          'title': false
        },
        {
          'id': 'pedBaixaEst',
          'desc': 'Pedido de venda',
          'erp2_0-2023': false,
          'erp2_1-2023': true,
          'erp2_2-2023': true,
          'erp3_0-2023': false,
          'erp3_1-2023': true,
          'erp3_2-2023': true,
          'erp3_3-2023': true,
          'erp3_free': false,
          'erp4_0-2025': false,
          'erp4_1-2025': true,
          'erp4_free': false,
          'erp5_0-2026': true,
          'erp5_1-2026': true,
          'erp5_2-2026': true,
          'title': false
        },
        {
          'id': 'pedTit',
          'desc': 'Rastreabilidade do pedido',
          'erp2_0-2023': true,
          'erp2_1-2023': true,
          'erp2_2-2023': true,
          'erp3_0-2023': true,
          'erp3_1-2023': true,
          'erp3_2-2023': true,
          'erp3_3-2023': true,
          'erp3_free': true,
          'erp4_0-2025': true,
          'erp4_1-2025': true,
          'erp4_free': true,
          'erp5_0-2026': true,
          'erp5_1-2026': true,
          'erp5_2-2026': true,
          'title': false
        },
        {
          'id': 'consDados',
          'desc': 'Desconto sobre desconto',
          'erp2_0-2023': true,
          'erp2_1-2023': true,
          'erp2_2-2023': true,
          'erp3_0-2023': true,
          'erp3_1-2023': true,
          'erp3_2-2023': true,
          'erp3_3-2023': true,
          'erp3_free': true,
          'erp4_0-2025': true,
          'erp4_1-2025': true,
          'erp4_free': true,
          'erp5_0-2026': true,
          'erp5_1-2026': true,
          'erp5_2-2026': true,
          'title': false
        },
        {
          'id': 'cliCart',
          'desc': 'Consulta e relatório de pedidos de venda',
          'erp2_0-2023': true,
          'erp2_1-2023': true,
          'erp2_2-2023': true,
          'erp3_0-2023': true,
          'erp3_1-2023': true,
          'erp3_2-2023': true,
          'erp3_3-2023': true,
          'erp3_free': false,
          'erp4_0-2025': true,
          'erp4_1-2025': true,
          'erp4_free': false,
          'erp5_0-2026': true,
          'erp5_1-2026': true,
          'erp5_2-2026': true,
          'title': false
        },
        {
          'id': 'perfCart',
          'desc': 'Consulta e relatório de produtos vendidos',
          'erp2_0-2023': true,
          'erp2_1-2023': true,
          'erp2_2-2023': true,
          'erp3_0-2023': true,
          'erp3_1-2023': true,
          'erp3_2-2023': true,
          'erp3_3-2023': true,
          'erp3_free': false,
          'erp4_0-2025': true,
          'erp4_1-2025': true,
          'erp4_free': false,
          'erp5_0-2026': true,
          'erp5_1-2026': true,
          'erp5_2-2026': true,
          'title': false
        },
        {
          'id': 'Abc',
          'desc': 'Consulta de vendas por carteira de clientes',
          'erp2_0-2023': true,
          'erp2_1-2023': true,
          'erp2_2-2023': true,
          'erp3_0-2023': true,
          'erp3_1-2023': true,
          'erp3_2-2023': true,
          'erp3_3-2023': true,
          'erp3_free': false,
          'erp4_0-2025': true,
          'erp4_1-2025': true,
          'erp4_free': false,
          'erp5_0-2026': true,
          'erp5_1-2026': true,
          'erp5_2-2026': true,
          'title': false
        },
        {
          'id': 'clieVend',
          'desc': 'Curva ABC por clientes',
          'erp2_0-2023': true,
          'erp2_1-2023': true,
          'erp2_2-2023': true,
          'erp3_0-2023': true,
          'erp3_1-2023': true,
          'erp3_2-2023': true,
          'erp3_3-2023': true,
          'erp3_free': false,
          'erp4_0-2025': true,
          'erp4_1-2025': true,
          'erp4_free': false,
          'erp5_0-2026': true,
          'erp5_1-2026': true,
          'erp5_2-2026': true,
          'title': false
        },
        {
          'id': 'listCli',
          'desc': 'Consulta de ranking de vendedores',
          'erp2_0-2023': true,
          'erp2_1-2023': true,
          'erp2_2-2023': true,
          'erp3_0-2023': true,
          'erp3_1-2023': true,
          'erp3_2-2023': true,
          'erp3_3-2023': true,
          'erp3_free': false,
          'erp4_0-2025': true,
          'erp4_1-2025': true,
          'erp4_free': false,
          'erp5_0-2026': true,
          'erp5_1-2026': true,
          'erp5_2-2026': true,
          'title': false
        },
        {
          'id': 'vendRank',
          'desc': 'Anexar documentos ao pedido',
          'erp2_0-2023': false,
          'erp2_1-2023': false,
          'erp2_2-2023': true,
          'erp3_0-2023': false,
          'erp3_1-2023': false,
          'erp3_2-2023': false,
          'erp3_3-2023': true,
          'erp3_free': false,
          'erp4_0-2025': false,
          'erp4_1-2025': false,
          'erp4_free': false,
          'erp5_0-2026': false,
          'erp5_1-2026': false,
          'erp5_2-2026': true,
          'title': false
        },
        {
          'id': 'rep',
          'desc': 'Representante(s)',
          'erp2_0-2023': false,
          'erp2_1-2023': false,
          'erp2_2-2023': '15',
          'erp3_0-2023': false,
          'erp3_1-2023': false,
          'erp3_2-2023': false,
          'erp3_3-2023': '15',
          'erp3_free': false,
          'erp4_0-2025': false,
          'erp4_1-2025': false,
          'erp4_free': false,
          'erp5_0-2026': false,
          'erp5_1-2026': false,
          'erp5_2-2026': '10',
          'title': false
        },
        {
          'id': 'est',
          'desc': 'Estoque',
          'title': true
        },
        {
          'id': 'visitLim',
          'desc': 'Importação de estoque pela planilha',
          'erp2_0-2023': true,
          'erp2_1-2023': true,
          'erp2_2-2023': true,
          'erp3_0-2023': true,
          'erp3_1-2023': true,
          'erp3_2-2023': true,
          'erp3_3-2023': true,
          'erp3_free': true,
          'erp4_0-2025': true,
          'erp4_1-2025': true,
          'erp4_free': true,
          'erp5_0-2026': true,
          'erp5_1-2026': true,
          'erp5_2-2026': true,
          'title': false
        },
        {
          'id': 'imgProd',
          'desc': 'Controle de estoque do produto por lote, validade e local',
          'erp2_0-2023': true,
          'erp2_1-2023': true,
          'erp2_2-2023': true,
          'erp3_0-2023': true,
          'erp3_1-2023': true,
          'erp3_2-2023': true,
          'erp3_3-2023': true,
          'erp3_free': true,
          'erp4_0-2025': true,
          'erp4_1-2025': true,
          'erp4_free': true,
          'erp5_0-2026': true,
          'erp5_1-2026': true,
          'erp5_2-2026': true,
          'title': false
        },
        {
          'id': 'gradProd',
          'desc': 'Ajuste de estoque',
          'erp2_0-2023': true,
          'erp2_1-2023': true,
          'erp2_2-2023': true,
          'erp3_0-2023': true,
          'erp3_1-2023': true,
          'erp3_2-2023': true,
          'erp3_3-2023': true,
          'erp3_free': true,
          'erp4_0-2025': true,
          'erp4_1-2025': true,
          'erp4_free': true,
          'erp5_0-2026': true,
          'erp5_1-2026': true,
          'erp5_2-2026': true,
          'title': false
        },
        {
          'id': 'tabPre',
          'desc': 'Impressão da etiqueta do produto',
          'erp2_0-2023': true,
          'erp2_1-2023': true,
          'erp2_2-2023': true,
          'erp3_0-2023': true,
          'erp3_1-2023': true,
          'erp3_2-2023': true,
          'erp3_3-2023': true,
          'erp3_free': true,
          'erp4_0-2025': true,
          'erp4_1-2025': true,
          'erp4_free': true,
          'erp5_0-2026': true,
          'erp5_1-2026': true,
          'erp5_2-2026': true,
          'title': false
        },
        {
          'id': 'tabDesc',
          'desc': 'Consulta do estoque atual',
          'erp2_0-2023': true,
          'erp2_1-2023': true,
          'erp2_2-2023': true,
          'erp3_0-2023': true,
          'erp3_1-2023': true,
          'erp3_2-2023': true,
          'erp3_3-2023': true,
          'erp3_free': true,
          'erp4_0-2025': true,
          'erp4_1-2025': true,
          'erp4_free': true,
          'erp5_0-2026': true,
          'erp5_1-2026': true,
          'erp5_2-2026': true,
          'title': false
        },
        {
          'id': 'intCad',
          'desc': 'Consulta do saldo em estoque com quantidade mínima',
          'erp2_0-2023': true,
          'erp2_1-2023': true,
          'erp2_2-2023': true,
          'erp3_0-2023': true,
          'erp3_1-2023': true,
          'erp3_2-2023': true,
          'erp3_3-2023': true,
          'erp3_free': false,
          'erp4_0-2025': true,
          'erp4_1-2025': true,
          'erp4_free': false,
          'erp5_0-2026': true,
          'erp5_1-2026': true,
          'erp5_2-2026': true,
          'title': false
        },
        {
          'id': 'gruCli',
          'desc': 'Consulta da movimentação de entradas e saídas do estoque',
          'erp2_0-2023': true,
          'erp2_1-2023': true,
          'erp2_2-2023': true,
          'erp3_0-2023': true,
          'erp3_1-2023': true,
          'erp3_2-2023': true,
          'erp3_3-2023': true,
          'erp3_free': false,
          'erp4_0-2025': true,
          'erp4_1-2025': true,
          'erp4_free': false,
          'erp5_0-2026': true,
          'erp5_1-2026': true,
          'erp5_2-2026': true,
          'title': false
        },
        {
          'id': 'fin',
          'desc': 'Financeiro',
          'title': true
        },
        {
          'id': 'ctr',
          'desc': 'Contas a receber',
          'erp2_0-2023': true,
          'erp2_1-2023': true,
          'erp2_2-2023': true,
          'erp3_0-2023': true,
          'erp3_1-2023': true,
          'erp3_2-2023': true,
          'erp3_3-2023': true,
          'erp3_free': true,
          'erp4_0-2025': true,
          'erp4_1-2025': true,
          'erp4_free': true,
          'erp5_0-2026': true,
          'erp5_1-2026': true,
          'erp5_2-2026': true,
          'title': false
        },
        {
          'id': 'ctp',
          'desc': 'Contas a pagar',
          'erp2_0-2023': true,
          'erp2_1-2023': true,
          'erp2_2-2023': true,
          'erp3_0-2023': true,
          'erp3_1-2023': true,
          'erp3_2-2023': true,
          'erp3_3-2023': true,
          'erp3_free': true,
          'erp4_0-2025': true,
          'erp4_1-2025': true,
          'erp4_free': true,
          'erp5_0-2026': true,
          'erp5_1-2026': true,
          'erp5_2-2026': true,
          'title': false
        },
        {
          'id': 'bx',
          'desc': 'Baixa de títulos',
          'erp2_0-2023': true,
          'erp2_1-2023': true,
          'erp2_2-2023': true,
          'erp3_0-2023': true,
          'erp3_1-2023': true,
          'erp3_2-2023': true,
          'erp3_3-2023': true,
          'erp3_free': true,
          'erp4_0-2025': true,
          'erp4_1-2025': true,
          'erp4_free': true,
          'erp5_0-2026': true,
          'erp5_1-2026': true,
          'erp5_2-2026': true,
          'title': false
        },
        {
          'id': 'nfManifesto',
          'desc': 'Baixa de títulos',
          'erp2_0-2023': true,
          'erp2_1-2023': true,
          'erp2_2-2023': true,
          'erp3_0-2023': true,
          'erp3_1-2023': true,
          'erp3_2-2023': true,
          'erp3_3-2023': true,
          'erp3_free': true,
          'erp4_0-2025': true,
          'erp4_1-2025': true,
          'erp4_free': true,
          'erp5_0-2026': true,
          'erp5_1-2026': true,
          'erp5_2-2026': true,
          'title': false
        },
        {
          'id': 'nfIInut',
          'desc': 'Impressão do recibo',
          'erp2_0-2023': true,
          'erp2_1-2023': true,
          'erp2_2-2023': true,
          'erp3_0-2023': true,
          'erp3_1-2023': true,
          'erp3_2-2023': true,
          'erp3_3-2023': true,
          'erp3_free': true,
          'erp4_0-2025': true,
          'erp4_1-2025': true,
          'erp4_free': true,
          'erp5_0-2026': true,
          'erp5_1-2026': true,
          'erp5_2-2026': true,
          'title': false
        },
        {
          'id': 'nfeIMpSit',
          'desc': 'Consulta de posição do financeiro',
          'erp2_0-2023': true,
          'erp2_1-2023': true,
          'erp2_2-2023': true,
          'erp3_0-2023': true,
          'erp3_1-2023': true,
          'erp3_2-2023': true,
          'erp3_3-2023': true,
          'erp3_free': false,
          'erp4_0-2025': true,
          'erp4_1-2025': true,
          'erp4_free': false,
          'erp5_0-2026': true,
          'erp5_1-2026': true,
          'erp5_2-2026': true,
          'title': false
        },
        {
          'id': 'nfeCons&Rel',
          'desc': 'Consulta de baixas de títulos',
          'erp2_0-2023': true,
          'erp2_1-2023': true,
          'erp2_2-2023': true,
          'erp3_0-2023': true,
          'erp3_1-2023': true,
          'erp3_2-2023': true,
          'erp3_3-2023': true,
          'erp3_free': false,
          'erp4_0-2025': true,
          'erp4_1-2025': true,
          'erp4_free': false,
          'erp5_0-2026': true,
          'erp5_1-2026': true,
          'erp5_2-2026': true,
          'title': false
        },
        {
          'id': 'Estoque',
          'desc': 'Consulta do fluxo de caixa',
          'erp2_0-2023': true,
          'erp2_1-2023': true,
          'erp2_2-2023': true,
          'erp3_0-2023': true,
          'erp3_1-2023': true,
          'erp3_2-2023': true,
          'erp3_3-2023': true,
          'erp3_free': false,
          'erp4_0-2025': true,
          'erp4_1-2025': true,
          'erp4_free': false,
          'erp5_0-2026': true,
          'erp5_1-2026': true,
          'erp5_2-2026': true,
          'title': false
        },
        {
          'id': 'estControleProd',
          'desc': 'Consulta DRE',
          'erp2_0-2023': false,
          'erp2_1-2023': true,
          'erp2_2-2023': true,
          'erp3_0-2023': false,
          'erp3_1-2023': true,
          'erp3_2-2023': true,
          'erp3_3-2023': true,
          'erp3_free': false,
          'erp4_0-2025': false,
          'erp4_1-2025': true,
          'erp4_free': false,
          'erp5_0-2026': false,
          'erp5_1-2026': true,
          'erp5_2-2026': true,
          'title': false
        },
        {
          'id': 'estExcel',
          'desc': 'Emissão de boletos',
          'erp2_0-2023': false,
          'erp2_1-2023': false,
          'erp2_2-2023': true,
          'erp3_0-2023': false,
          'erp3_1-2023': false,
          'erp3_2-2023': false,
          'erp3_3-2023': true,
          'erp3_free': false,
          'erp4_0-2025': false,
          'erp4_1-2025': false,
          'erp4_free': false,
          'erp5_0-2026': false,
          'erp5_1-2026': true,
          'erp5_2-2026': true,
          'title': false
        },
        {
          'id': 'estLote',
          'desc': 'Compras',
          'title': true
        },
        {
          'id': 'estAjuste',
          'desc': 'Nota fiscal de entrada pelo arquivo XML',
          'erp2_0-2023': true,
          'erp2_1-2023': true,
          'erp2_2-2023': true,
          'erp3_0-2023': true,
          'erp3_1-2023': true,
          'erp3_2-2023': true,
          'erp3_3-2023': true,
          'erp3_free': true,
          'erp4_0-2025': true,
          'erp4_1-2025': true,
          'erp4_free': true,
          'erp5_0-2026': true,
          'erp5_1-2026': true,
          'erp5_2-2026': true,
          'title': false
        },
        {
          'id': 'etqProd',
          'desc': 'Consulta e relatório de notas fiscais de entrada',
          'erp2_0-2023': true,
          'erp2_1-2023': true,
          'erp2_2-2023': true,
          'erp3_0-2023': true,
          'erp3_1-2023': true,
          'erp3_2-2023': true,
          'erp3_3-2023': true,
          'erp3_free': false,
          'erp4_0-2025': true,
          'erp4_1-2025': true,
          'erp4_free': false,
          'erp5_0-2026': true,
          'erp5_1-2026': true,
          'erp5_2-2026': true,
          'title': false
        },
        {
          'id': 'finandestceiro',
          'desc': 'Manifestação do destinatário',
          'erp2_0-2023': false,
          'erp2_1-2023': true,
          'erp2_2-2023': true,
          'erp3_0-2023': false,
          'erp3_1-2023': true,
          'erp3_2-2023': true,
          'erp3_3-2023': true,
          'erp3_free': false,
          'erp4_0-2025': false,
          'erp4_1-2025': true,
          'erp4_free': false,
          'erp5_0-2026': false,
          'erp5_1-2026': false,
          'erp5_2-2026': true,
          'title': false
        },
        {
          'id': 'titCont',
          'desc': 'Nota fiscal de importação por XML',
          'erp2_0-2023': false,
          'erp2_1-2023': true,
          'erp2_2-2023': true,
          'erp3_0-2023': false,
          'erp3_1-2023': true,
          'erp3_2-2023': true,
          'erp3_3-2023': true,
          'erp3_free': false,
          'erp4_0-2025': false,
          'erp4_1-2025': true,
          'erp4_free': false,
          'erp5_0-2026': false,
          'erp5_1-2026': true,
          'erp5_2-2026': true,
          'title': false
        }
      ],
    }
  },
  methods: {
    isBoolean(value) {
      return typeof value === "boolean";
    },

  },
  mounted() {

  }
}
</script>

<style scoped>
table {
  max-width: 500px;
  margin: 0 auto;
  width: 90%;
  margin-top: 61px;
}

thead .table-col-1,
thead .table-col-2 {
  background: '';
  color: '';
  border: 0;
  font-size: 16px;
}

.table-col-2 th {
  font-weight: bold;
  font-size: 14px;
  border: 0;
}

.table-col-1 {
  word-break: break-all;
  width: 100%;
  max-width: 200px;
  display: flex;
  justify-content: center;
  padding: 1rem 10px;
  border-bottom: 1px solid;
  border-color: #e3e3e3;
  border-left: 1px solid #e3e3e3;
  font-size: 12px;
}

.table-col-full {
  background: #f7f7f7;
  width: 100%;
  display: flex;
  justify-content: start;
  padding: 1rem 1.5rem;
  text-align: left;
  font-weight: 500;
  border: 1px solid #f3f3f4;
  font-size: 16px;
}

.table-col-2 {
  word-break: break-all;
  max-width: 480px;
  padding: 1rem 1.5rem;
  width: 100%;
  font-weight: 400;
  border-bottom: 1px solid;
  border-color: #f3f3f4;
  font-size: 14px;
}
</style>




// WEBPACK FOOTER //
// src/components/planos-precos-checklist.vue